define('collection/ReviewCollection',['require','lib/collection/PaginatedCollection','model/ReviewModel'],function (require) {

    var PaginatedCollection = require('lib/collection/PaginatedCollection');
    var ReviewModel = require('model/ReviewModel');

    /**
     * Reviews collection
     *
     * @class ReviewsCollection
     */
    return PaginatedCollection.extend({

        baseUrl: '/v2/review/list/',
        //url: '/review/list/',
        urlTemplate: null,
        model: ReviewModel,
        perPage : null,
        page : 1,

        comparator: function (a, b) {
            return b.get('id') - a.get('id');
        },

        setLimit : function (limit) {
            this.perPage = limit;
        },

        getLimit : function () {
            return parseInt(this.perPage);
        },

        setPage : function (page) {
            if(page && parseInt(page)>=1){
                this.page = parseInt(page);
            }
        },

        withUserLike : function () {
            var fmodel = this.first();
            if(fmodel && !_.isUndefined(fmodel.get('like_type'))){
                return true;
            }
            return false;
        },

        /**
         * delete review
         *
         * @param model
         */
        deleteReview: function (model) {
            model.destroy({
                silent: true,
                wait: true,
                success: _.bind(function () {
                    this.fetch();
                }, this)
            });
        },


    });

});
